import React, {useState} from 'react';

function Skills() {
  const [skills] = useState([
    'HTML/HTML5',
    'CSS/CSS3',
    'Javascript',
    'ReactJS',
    'Redux',
    'LESS/SASS',
    'Semantic Markup',
    'Responsive Design',
    'Accessibility',
    'Grunt/Gulp',
    'Node',
    'Express',
    'RESTful API',
    'PostgreSQL',
    'Deployment',
    'UX/UI',
    'Python',
  ]);

  return (
    <section id="skills" className="px-10 py-4 m-auto bg-white sm:shadow-md sm:w-2/3">
      <h2 className="w-full text-3xl font-bold ">Skills</h2>
      <ul className=" flex flex-wrap  ">
        {skills.map((skill, index) => (
          <li key={index} className="inline pr-2">
            {' '}
            &bull; {skill}
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Skills;
